// =========================================================
// * Vue Material Dashboard Laravel - v1.1.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vue-material-dashboard-laravel
// * Copyright Creative Tim (https://www.creative-tim.com) & UPDIVISION (https://www.updivision.com)
//
// * Coded by www.creative-tim.com & www.updivision.com
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import Vue from "vue";
import axios from "axios";

// Plugins
import App from "./App.vue";
//import Chartist from "chartist";
import VueAxios from "vue-axios";
import vuetify from '@/plugins/vuetify'; // path to vuetify export
import DashboardPlugin from "./material-dashboard";
//import * as firebase from "firebase/app";
//import "firebase/firestore";
//import { initializeAnalytics } from 'firebase/analytics';

//filters
import getLocalisationPage from "./filters/getLocalisationPage";
import getLocalisationPages from "./filters/getLocalisationPages";
// plugin setup
Vue.use(DashboardPlugin);
Vue.use(VueAxios, axios);

// router & store setup
import router from "./router";
import store from "./store";
// const firebaseConfig = {
//   apiKey: "AIzaSyDtMyhk06zwdT7km1TZ7KyvvMXrZBENAc4",
//   authDomain: "app-fixthephoto.firebaseapp.com",
//   databaseURL: "https://app-fixthephoto-default-rtdb.firebaseio.com",
//   projectId: "app-fixthephoto",
//   storageBucket: "app-fixthephoto.appspot.com",
//   messagingSenderId: "64170057279",
//   appId: "1:64170057279:web:b603b0c393e50293c3628a",
//   measurementId: "G-EY0YP2C395"
// };
//
// let analyticsApp = firebase.initializeApp(firebaseConfig);
// let analyticsInit = initializeAnalytics(analyticsApp);

Vue.config.productionTip = false;
// global library setup
// Vue.prototype.$Chartist = Chartist;
// Vue.prototype.$analyticsApp = analyticsApp;
// Vue.prototype.$analyticsInit = analyticsInit;
Vue.prototype.$filtergetLocalisationPage = getLocalisationPage;
Vue.prototype.$filtergetLocalisationPages = getLocalisationPages;


/* eslint-disable no-new */
const app = new Vue({
  vuetify,
  router: router,
  store: store,
  el: "#app",
  render: h => h(App)
});

store.$app = app;
